import { render } from "./TransferList.vue?vue&type=template&id=cf74437e"
import script from "./TransferList.vue?vue&type=script&lang=js"
export * from "./TransferList.vue?vue&type=script&lang=js"

import "./TransferList.vue?vue&type=style&index=0&id=cf74437e&lang=scss"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__